import { createSlice } from '@reduxjs/toolkit';
import { Distribution_State } from '../../generated/mlmbox/types/distribution';

const initialState: { value: Distribution_State | null } = {
    value: null,
};

export const distributionSlice = createSlice({
    name: 'distribution',
    initialState,
    reducers: {
        setDistribution(state, { payload }: { payload: Distribution_State }) {
            state.value = payload;
        },
    },
});

export const { setDistribution } = distributionSlice.actions;

export default distributionSlice.reducer;
